import { createGlobalStyle } from 'styled-components/macro';

const ReactourGlobalStyles = createGlobalStyle`
  .reactour__helper {
    outline: none;
  }
`;

export default ReactourGlobalStyles;
